module.exports = __webpack_public_path__ + "static/media/cursera.b43bd636.svg";